import { PropsWithChildren } from 'react';
import QuillDelta from 'quill-delta';
import { Flex, Box } from 'reflexbox';
import styled from 'styled-components';

import { Link } from '@treams/treams-routes';

import * as graphql from 'generated/graphql';

import QuillText from 'packages/kakapo-ui-kit/components/editors/QuillText';

import { Avatar } from './Avatar';
import { Stars } from './Stars';
import { Paragraph } from './Text';
import { Skeleton } from './Skeleton';

const Bubble = styled(Box)`
	background-color: ${(props) => props.theme.colors.lightBlueLight};
	border-radius: 6px;
	border: 1px solid ${(props) => props.theme.colors.lightBlue};
`;

const BubbleUserLink = styled(Link)`
	${Paragraph} {
		color: ${(props) => props.theme.colors.antracite};
		font-weight: bold;
	}
`;

export const TextBubble = Skeleton(
	function TextBubble(
		props: PropsWithChildren<{
			user: graphql.User | graphql.FeedbackRecipient;
			text?: QuillDelta;
			stars?: number;
		}>,
	) {
		return (
			<Flex flexGrow={1}>
				<Box mr={2} flexShrink={0} mt={2}>
					{'id' in props.user ? (
						<Link to={`/users/${props.user.id}`}>
							<Avatar user={props.user} size={30} />
						</Link>
					) : (
						<Avatar user={props.user} size={30} />
					)}
				</Box>
				<Bubble mb={2} py={10} px={15} flexGrow={1}>
					{'id' in props.user ? (
						<BubbleUserLink to={`/users/${props.user.id}`}>
							<Paragraph mb={1}>
								{props.user.firstName} {props.user.lastName}
							</Paragraph>
						</BubbleUserLink>
					) : (
						<Paragraph mb={1}>
							{props.user.firstName} {props.user.lastName}
						</Paragraph>
					)}
					<QuillText quill={props.text} />
					{props.stars && (
						<Box mt={2}>
							<Stars stars={props.stars} />
						</Box>
					)}

					{props.children}
				</Bubble>
			</Flex>
		);
	},
	function TextBubbleSkeleton() {
		return (
			<Flex flexGrow={1}>
				<Box mr={1}>
					<Avatar.Skeleton size={30} />
				</Box>

				<Bubble mb={2} py={10} px={15} flexGrow={1}>
					<Paragraph.Skeleton lines={1} mb={1} />
					<Paragraph.Skeleton lines={1} />
				</Bubble>
			</Flex>
		);
	},
);
